<template>
    <div class="h-full w-full">
        <base-form class="h-full w-full">
            <template #body>
                <div v-if="contacts.length > 0" class="w-full h-fit">
                    <div class="grid grid-cols-2 p-1 pb-3 border-b border-b-light-primary" v-for="contact in contacts" :key="contact.id">
                        <div class="flex flex-col w-full border-r border-dotted border-light-primary justify-start items-start px-3">
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Prefix:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactPrefixCell class="inline" :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">First Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactFirstNameCell class="inline" :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Middle Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactMiddleNameCell class="inline" :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Last Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactLastNameCell :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Suffix:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactSuffixCell :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Preferred Name:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactPreferredNameCell :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Email:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactPersonalEmailCell :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Phone:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ClientContactPhoneCell class="w-fit" :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                            <div class="flex justify-between items-center py-0.5 w-full h-9">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">LinkedIn Profile:</div>
                                <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                <div class="flex space-x-1 2xl:col-span-3">
                                    <ContactLinkedInCell :contact="contact.contact" @refetch-contacts="refetchClients" />
                                </div>
                            </div>
                            <div class="flex flex-col items-start py-0.5 w-full">
                                <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Personal Notes:</div>
                                <!-- <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div> -->
                                <div class="flex">
                                   <ClientContactPersonalNotesCell :client-contact="contact.contact" @refetch-clients="refetchClients" />
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col w-full justify-between items-start px-3">
                            <div class="flex flex-col w-full justify-start items-start">
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Title:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <ClientContactTitleCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Email:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <ClientContactBusinessEmailCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Phone:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <ClientContactBusinessPhoneCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Time Zone:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <ClientContactTimeZoneCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex justify-between items-center py-0.5 w-full h-9">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Is Primary:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex space-x-1 2xl:col-span-3">
                                        <ClientContactIsPrimaryCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex flex-col items-start py-0.5 w-full">
                                    <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800 pr-0">Users:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex">
                                        <ContactUsersCell :contact="contact.contact" :user-options="userOptions" @refetch-contacts="refetchClients" />
                                    </div>
                                </div>
                                <div class="flex flex-col items-start py-0.5 w-full">
                                    <div class="whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Business Notes:</div>
                                    <div class="border-b-2 border-dotted border-gray-400 flex-grow mx-1 "></div>
                                    <div class="flex">
                                        <ClientContactBusinessNotesCell :client-contact="contact" @refetch-clients="refetchClients" />
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="w-full flex flex-col justify-end items-end">
                                <div class="flex flex-row justify-end items-center col-span-2 2xl:col-span-4 space-x-1 w-full">
                                    <ClientContactMarkEmailVerifiedCell class="inline"  :client-contact="contactCompanyRelationships(contact)" @refetch-clients="refetchClients"  />
                                    <base-button-negative @click="removeClientContact(contact, contactCompanyRelationships(contact))">Archive</base-button-negative>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div v-else>
                    --
                </div>
                <!-- <ClientContactForm class="" v-for="(row, index) in formRows" :key="row.key" :company="row.company" @refetch-clients="refetchClients" @close-form="closeContactRow(index)"/> -->
            </template>
            <template #footer>
                <div class="flex flex-row justify-end py-0.5">
                    <base-button @click="addFormRow">Add Contact</base-button>
                </div>
            </template>
        </base-form>
    </div>
</template>


<script setup>
import {ref, computed, defineProps, defineEmits } from "vue";
import { useStore } from "vuex";
import ClientContactPrefixCell from "./client-contact-components/ClientContactPrefixCell.vue";
import ClientContactFirstNameCell from './client-contact-components/ClientContactFirstNameCell.vue';
import ClientContactMiddleNameCell from "./client-contact-components/ClientContactMiddleNameCell.vue";
import ClientContactLastNameCell from './client-contact-components/ClientContactLastNameCell.vue';
import ClientContactSuffixCell from './client-contact-components/ClientContactSuffixCell.vue';
import ClientContactTitleCell from './client-contact-components/ClientContactTitleCell.vue';
import ClientContactPersonalEmailCell from './client-contact-components/ClientContactPersonalEmailCell.vue';
import ClientContactPhoneCell from './client-contact-components/ClientContactPhoneCell.vue';
import ContactLinkedInCell from "../contact/contact-cell-components/ContactLinkedInCell.vue";
import ContactUsersCell from "../contact/contact-cell-components/ContactUsersCell.vue";
import ClientContactPersonalNotesCell from './client-contact-components/ClientContactPersonalNotesCell.vue';
import ClientContactIsPrimaryCell from "./client-contact-components/ClientContactIsPrimaryCell.vue";
// import ClientContactForm from "../client-contact-components/ClientContactForm.vue";
import ClientContactBusinessEmailCell from "./client-contact-components/ClientContactBusinessEmailCell.vue";
import ClientContactBusinessPhoneCell from "./client-contact-components/ClientContactBusinessPhoneCell.vue";
import ClientContactBusinessNotesCell from "./client-contact-components/ClientContactBusinessNotesCell.vue";
import ClientContactPreferredNameCell from "./client-contact-components/ClientContactPreferredNameCell.vue";
import ClientContactTimeZoneCell from "./client-contact-components/ClientContactTimeZoneCell.vue";
import {updateContactCompanyRelationship} from '@/services/Contact.js'
import { getUsers } from "@/services/User";
import { useToast } from 'vue-toast-notification';


const store = useStore()
const $toast = useToast()

const formRows = ref([])

const props = defineProps({
    client: Object
})

const showContactForm = ref(false)

const userOptions = ref([])

const emit = defineEmits(['refetch-clients', 'close'])

function refetchClients () {
    emit('refetch-clients')
}

const contacts = computed(() => {
    return props.client.contacts
})

function addFormRow(){
    formRows.value.push(
    {key: Math.random(), company: props.company}
    )
}
function closeContactRow(index) {
    formRows.value.splice(index, 1)
    // emit('close')
}

async function removeClientContact(contact, contactRelationship){
    const confirm_message = `You are about to archive ${contact.first_name} ${contact.last_name}, ${contactRelationship.title} at ${props.company.company_name}.\n Do you wish to proceed?`
    if(window.confirm(confirm_message)){
        const token = store.state.auth.token
        const data = JSON.stringify({
            "status": "inactive"
        })
        const response = await updateContactCompanyRelationship(contactRelationship.id, data, token)
        if (response.status == 200){
            $toast.open(
                {
                    message: `Contact archived for ${props.company.company_name}`,
                    type: 'success',
                    duration: 10000
                }
            )
            emit('refetch-clients')
            // emit('close')
        } else {
            $toast.open(
                {
                    message: `${response.response.data.detail}`,
                    type: 'error',
                    duration: 10000
                }
            )
        }
    }

}

async function setUserOptions() {
  const token = store.getters['auth/showToken']
  const payload = {
    endpoint: "?is_active=True",
    token: token
  }
  const result = await getUsers(payload)
  userOptions.value = result.users.map((user) => {
      return {value: user.id, label: `${user.first_name} ${user.last_name}`}
  })
}

setUserOptions()

</script>